export function validateFormFields(user) {
  const { email, first_name, last_name, phone } = user;

  const warnings = {
    email: !email,
    first_name: !first_name,
    last_name: !last_name,
    phone: !phone,
  };

  const atleastOneFieldWithWarning = Object.values(warnings).some((warning) => !!warning);

  if (atleastOneFieldWithWarning) {
    return warnings;
  }

  return null;
}

export function formatDataToCreateUser(user) {
  const {
    email,
    first_name,
    last_name,
    phone,
    commercial_communications_accepted,
    contact_instructions,
  } = user;

  return {
    username: email,
    first_name,
    last_name,
    phone,
    commercial_communications_accepted,
    contact_instructions,
  };
}

export function formatDataToEditUser(user) {
  if (!user) return {};

  return {
    ...user,
    username: user?.email,
  };
}
